//

import CssBaseline from './CssBaseline';
import Card from './Card';
import Button from './Button';
import LinearProgress from './LinearProgress';
import Input from './Input';
import Table from './Table';
import Dialog from './Dialog';
import AutoComplete from './AutoComplete';
import Slider from './Slider';
import Checkbox from './Checkbox';


// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return Object.assign(
    CssBaseline(theme),
    Card(theme),
    Button(theme),
    LinearProgress(theme),
    Input(theme),
    Checkbox(theme),
    Table(theme),
    Dialog(theme),
    AutoComplete(theme),
    Slider(theme),
  );
}
